import { PageLayout } from '~/components/PageLayout/PageLayout';
import { RegisterForm } from './components/register-form';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  return (
    <Fragment>
      <PageLayout.Heading text="Skapa konto" />
      <RegisterForm />
    </Fragment>
  );
}
